export default __webpack_public_path__ + "42e36e3d359253b1fc98e9f44cb12c57.svg";